import Vue from 'vue';
import Vuetify from 'vuetify';
import Vuebar from 'vuebar';
import VeeValidate from 'vee-validate';
import vClickOutside from 'v-click-outside';

import store from './store';
import router from './router';
import App from './App.vue';


Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.config.performance = true;

Vue.use(Vuetify, { iconfont: 'fa' });
Vue.use(Vuebar);
Vue.use(VeeValidate);
Vue.use(vClickOutside);

export const bus = new Vue();

new Vue({
    store,
    router,
    render: h => h(App),
}).$mount('#app');
